<template>
  <div id="nav">
    <div class="m-container">
      <div class="logo">
        <a href="/#/m/index">
          <img src="@/assets/imgs/logo-b.png" alt="Yangyu-group" />
        </a>
      </div>
      <div class="menu" v-on:click='subMenuShow = !subMenuShow'>
        <a href="javascript:void(0);"><img src="@/assets/imgs/m/menu.png" /></a>
      </div>
    </div>
    <transition name="fade">
      <div class="sub-menu" v-if='subMenuShow'>
        <div class="one">
          <div class="sub-menu-container">
            <a href="/#/m/index">主页</a>
          </div>
        </div>
        <div class="one">
          <div class="sub-menu-container">
            <a href="/#/m/home">集团介绍</a>
          </div>
        </div>
         <div class="one">
          <div class="sub-menu-container">
            <a href="/#/m/news">新闻中心</a>
          </div>
        </div>
        <div class="one">
          <div class="sub-menu-container">
            <a href="/#/m/contact">联系我们</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "navigation",
  data() {
    return {
      subMenuShow:false,
    };
  },
};
</script>

<style scoped>
#nav {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  background-color: white;
  width: 100vw;
  border-bottom: 1px solid #ccc;
}

#nav .m-container {
  display: flex;
  justify-content: space-between;
  padding: 0.22rem;
}

#nav .logo,
#nav .logo a,
#nav .logo a img {
  display: block;
  width: 1rem;
  height: 0.15rem;
}

#nav .menu,
#nav .menu a,
#nav .menu a img {
  display: block;
  width: 0.22rem;
  height: 0.13rem;
}
#nav .sub-menu {
  position: absolute;
  z-index: 1000;
  top: 0.6rem;
  left: 0;
  width: 100vw;
  background-color: white;
}
#nav .sub-menu .one {
  width: 100vw;
  height: 0.6rem;
  border-bottom: 1px solid #ccc;
  background-color: white;
}

#nav .sub-menu .one a {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 0.6rem;
  font-size: 0.16rem;
  color: #333;
  padding: 0 0.3rem;
}
#nav .sub-menu .one a:focus {
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/m/Nav.vue